import { Component } from '@angular/core';

@Component({
  selector: 'app-360-evaluation-empty-state',
  template: `
  <ion-card mode="ios" class="team-card">
    <img src="./assets/imgs/select-user.png" />
    <p>{{ '360evaluation.chooseEmployee' | translate | uppercase }}</p>
  </ion-card>`,
  styleUrls: ['./empty-state.component.scss']
})
export class Evaluation360EmptyStateComponent { }
